import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcNotice(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.214 3.162c1.493-.717 3.223.371 3.223 2.028v12.65a2.25 2.25 0 0 1-3.085 2.09l-.034-.014-2.64-1.37a2.75 2.75 0 0 1-2.74 2.518h-.5a2.75 2.75 0 0 1-2.75-2.75v-2.258h-1a2.75 2.75 0 0 1-2.75-2.75v-3a2.75 2.75 0 0 1 2.75-2.75h1.546c.407 0 .806-.11 1.155-.318l6.794-4.061zm.675 1.34-6.73 4.023a3.75 3.75 0 0 1-1.925.531H4.688c-.69 0-1.25.56-1.25 1.25v3c0 .69.56 1.25 1.25 1.25H6.33a3.75 3.75 0 0 1 1.728.422l6.88 3.57a.75.75 0 0 0 1-.707V5.19a.75.75 0 0 0-1.05-.689M7.367 16.31l2.82 1.464v.54c0 .69-.56 1.25-1.25 1.25h-.5c-.69 0-1.25-.56-1.25-1.25v-2.087q.091.038.18.083",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.438 11.21a.75.75 0 1 0 0 1.5h1.875a.75.75 0 0 0 0-1.5zM18.794 14.99a.75.75 0 0 1 1.03-.257l1.874 1.125a.75.75 0 1 1-.771 1.286l-1.875-1.125a.75.75 0 0 1-.258-1.029M21.698 8.144a.75.75 0 0 0-.771-1.286l-1.875 1.125a.75.75 0 1 0 .771 1.286z"
  }));
}
var IcNotice = createNolIcon(/*#__PURE__*/forwardRef(SvgIcNotice));

export { IcNotice as I };
